import Calculator from './Calculator';
import Form from './Form';
const Preview = ({ selectedTab = 'form' }) => {
  return selectedTab === 'form' ? <Form /> : <Calculator />;
};

export default Preview;
